import * as React from "react";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import IconButton from "@mui/material/IconButton";
import colors from "Utils/colors";
import { useFavouritesStore, favouritesStore } from "Utils/useFavouritesStore";
import {
  getCookieConsent,
  CookieModal,
  openCookieModal,
} from "Molecules/Cookies";

const { dmiRedHeart } = colors;

const FavouriteButton = ({ item, size = "small" }) => {
  const favourites = useFavouritesStore();

  const isFav = favourites.some((f) => f.id === item.id || f?.gid === item.id);

  const toggle = (event) => {
    event.stopPropagation();

    if (isFav) {
      favouritesStore.remove(item.id);
    } else {
      if (!getCookieConsent()) {
        openCookieModal();
        return;
      }
      const clone = { ...item };
      delete clone.favourite;
      favouritesStore.add(clone);
    }
  };

  return (
    <>
      <CookieModal />
      <IconButton onClick={toggle} size={size} sx={{ color: dmiRedHeart }}>
        {isFav ? (
          <FavoriteIcon fontSize={size} />
        ) : (
          <FavoriteBorderIcon fontSize={size} />
        )}
      </IconButton>
    </>
  );
};
export default FavouriteButton;
